var _path, _ellipse, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPercentT(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 69,
    viewBox: "0 0 81 69",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.5366 10.5863L76.7629 40.9505C78.6264 42.8865 78.6264 45.9492 76.7629 47.8853L60.1076 65.189C58.1407 67.2325 54.8697 67.2325 52.9028 65.189L23.8639 35.0195C22.9672 34.0879 22.4663 32.8452 22.4663 31.5521V14.0537C22.4663 11.2923 24.7049 9.05371 27.4663 9.05371H43.9342C45.2934 9.05371 46.594 9.60705 47.5366 10.5863Z",
    fill: "#E72626"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 33.2966,
    cy: 19.4854,
    rx: 2.32083,
    ry: 2.41119,
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.7088 19.658C33.9503 19.524 34.0374 19.2196 33.9033 18.9781C33.7693 18.7367 33.465 18.6496 33.2235 18.7836L33.7088 19.658ZM32.304 9.10123L32.7535 9.32021L33.1915 8.42122L32.742 8.20224L32.304 9.10123ZM33.2235 18.7836C26.3143 22.6187 19.464 22.2574 13.8946 19.9666C8.3046 17.6673 4.03977 13.4381 2.32301 9.60289C1.46366 7.68309 1.27071 5.92936 1.77522 4.5768C2.26819 3.25518 3.4735 2.1967 5.69367 1.73963C7.93077 1.27907 11.1557 1.44374 15.5557 2.57185C19.9485 3.69809 25.4771 5.77528 32.304 9.10123L32.742 8.20224C25.8759 4.85721 20.2819 2.75124 15.8041 1.60318C11.3335 0.456996 7.93987 0.25623 5.49202 0.760169C3.02725 1.26759 1.48127 2.50353 0.838282 4.22731C0.20684 5.92016 0.493262 7.96282 1.41028 10.0115C3.24627 14.1131 7.72216 18.509 13.5142 20.8914C19.3269 23.2823 26.4999 23.6594 33.7088 19.658L33.2235 18.7836Z",
    fill: "url(#paint0_linear_10216_25564)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_10216_25564",
    x1: 33.9335,
    y1: 18.5478,
    x2: 36.8927,
    y2: 14.5603,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E1E1E",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPercentT);
export default __webpack_public_path__ + "static/media/percent-t.988d656e1b9257260c218abc21e03fe0.svg";
export { ForwardRef as ReactComponent };